module.exports = __webpack_public_path__ + "img/bugger_04.7f50fee5.png";